import { FeatureFlags } from 'common/feature_flags';

// Unfortunately the feature flag for turning on a broad swath of SCGC
// functionality is behind a flag name that does not imply this at all.
export const scgcEnabled = () => FeatureFlags.value('strict_permissions');
